/* tslint:disable */

export class Pair {
		Id: number;
		ValueForTrue: string;
		ValueForFalse: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Pair.ts